import Nav from "./Navigation.js";

const locationsData = [
  { id: 1, name: "Backrooms", imagePath: "Backrooms.png" },
  { id: 2, name: "Bamboo Forest", imagePath: "BambooForest.png" },
  { id: 3, name: "Brick Maze", imagePath: "BrickMaze.png"},
  { id: 4, name: "Carnival", imagePath: "Carnival.png" },
  {
    id: 5,
    name: "Castle",
    imagePath: "Castle.png"
  },
  { id: 6, name: "Cornfield", imagePath: "Cornfield.png" },
  { id: 7, name: "Crypts", imagePath: "Crypts.png" },
  { id: 8, name: "Dead Forest", imagePath: "DeadForest.png" },
  { id: 9, name: "Fog City", imagePath: "FogCity.png" },
  { id: 10, name: "Forest", imagePath: "Forest.png"},
  { id: 11, name: "Jungle", imagePath: "Jungle.png" },
  { id: 12, name: "Kept Hedges", imagePath: "KeptHedges.png" },
  { id: 13, name: "Manor", imagePath: "Manor.png" },
  { id: 14, name: "Mines", imagePath: "Mines.png" },
  { id: 15, name: "Snowy Hedges", imagePath: "SnowyHedges.png" },
  { id: 16, name: "Swamp", imagePath: "Swamp.png" },
  { id: 17, name: "Trenches", imagePath: "Trenches.png" },
  { id: 18, name: "Unkept Hedges", imagePath: "UnkeptHedges.png" },
];

export default function LocationSolver() {

  const renderItem = (location) => (
    <div key={location.name}>
      <img
        className="object-scale-down h-48 cursor-pointer"
        src={require(`../imagesmaps/${location.imagePath}`)}
        alt={location.name}
      />
      <div>{location.name}</div>
    </div>
  );

  return (
    <div className="text-white">
      <Nav />
        <div className="items-center grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4">
          {locationsData.map((location) => (
            <div key={location.id}>{renderItem(location)}</div>
          ))}
        </div>
    </div>
  );
}
